export const fetchMinidashboards = filter => ({
  method: 'GET',
  url: `/dashboard/minidashboard/pro${filter ? `/${filter}` : ''}`
});

export const fetchMessages = () => ({
  method: 'GET',
  url: '/dashboard/messages/get'
})

export const fetchCounters = () => ({
  method: 'POST',
  url: '/dashboard/enterprise/dynamic',
})

export const fetchEvents = ({ year, month }) => ({
  method: 'GET',
  url: `/dashboard/events?month=${month}&year=${year}`
})

export const fetchAmount = () => ({
  method: 'GET',
  url: '/dashboard/enterprise/amounts'
})

export const getContractTypes = () => ({
  method: 'GET',
  url: '/dashboard/enterprise/contract-types'
});

export const getSignedByTime = () => ({
  method: 'GET',
  url: '/dashboard/enterprise/signed'
});
